import sliderImage1Source from "../../../assets/photos/carousel-1.jpeg";
import sliderImage2Source from "../../../assets/photos/carousel-2.jpeg";
import sliderImage3Source from "../../../assets/photos/carousel-3.jpeg";
import sliderImage4Source from "../../../assets/photos/carousel-4.jpeg";
import sliderImage5Source from "../../../assets/photos/carousel-5.jpeg";
import sliderImage6Source from "../../../assets/photos/carousel-6.jpeg";
import sliderImage7Source from "../../../assets/photos/carousel-7.jpeg";
import sliderImage8Source from "../../../assets/photos/carousel-8.jpeg";
import sliderImage9Source from "../../../assets/photos/carousel-9.jpeg";
import sliderImage10Source from "../../../assets/photos/carousel-10.jpeg";
import sliderImage11Source from "../../../assets/photos/carousel-11.jpeg";

const sliderImages = [
  {
    img: sliderImage1Source,
    date: "julio 2023",
    title: "Llegaron los 35",
    description:
      "Festejo de cumpleaños de Teo en La Calle bar. Convocatoria record",
  },
  {
    img: sliderImage2Source,
    date: "marzo 2018",
    title: "Machu Picchu",
    description:
      "Pretemporada de Chachos en Perú, entrenando a más de 2.400 metros de altura",
  },
  {
    img: sliderImage3Source,
    date: "marzo 2018",
    title: "Parque Pisac",
    description:
      "Combatiendo la altura a pura foto para tomar aire y seguir el recorrido",
  },
  {
    img: sliderImage4Source,
    date: "diciembre 2017",
    title: "Chachos Libres",
    description:
      "Últimos recuerdos de Chachos en la categoría libres de CUBA antes que la edad empiece a pasar factura",
  },
  {
    img: sliderImage5Source,
    date: "octubre 2022",
    title: "Merlo San Luis",
    description:
      "Trekking entre las rocas a puro ritmo liderados por la dupla de hermanos Cebreiro",
  },
  {
    img: sliderImage6Source,
    date: "marzo 2018",
    title: "La puerta del sol",
    description:
      "No se llegó a hacer el Camino del Inca, pero no quisimos desaprovechar la oportunidad de una buena placa con vista panorámica de Machu Picchu",
  },
  {
    img: sliderImage7Source,
    date: "octubre 2023",
    title: "La cantera",
    description:
      "Los más jóvenes hacen fila para abrazar a su ídolo quien deslumbra no sólo con su talento, sino también con su carisma",
  },
  {
    img: sliderImage8Source,
    date: "junio 2018",
    title: "Mundial 2018",
    description:
      "Hasta Nizhny Novgorod nos fuimos para alentar a la selección, aunque aquella noche fue un baile a favor de Croacia. Mucha cerveza para pasar el mal momento",
  },
  {
    img: sliderImage9Source,
    date: "febrero 2023",
    title: "Vuelta a las canchas",
    description:
      "Chachos volvía renovado a la división +32 después de un año de ausentarse de las canchas. Todo era alegría y celebración, menos para Bimbo que sufre en el fondo",
  },
  {
    img: sliderImage10Source,
    date: "diciembre 2023",
    title: "Fin de año",
    description:
      "Cerramos un gran año en Los Naranjos con anfitriones de lujo como nos tienen habitualmente acostumbrados. A brindar por un 2024 de nuevos éxitos",
  },
  {
    img: sliderImage11Source,
    date: "febrero 2024",
    title: "Despedida del candado",
    description:
      "Toda la banda festejando la visita del candado y el cumpleaños de Santi. Nueva vuelta a Suiza a la espera de que en algún momento se instalen definitivamente en Argentina",
  },
];

export default sliderImages;
